import * as React from 'react';
import {Briefcase} from 'lucide-react';
import ResourceFigure from './ResourceFigure';

export default function ProjectResourceFigure({className}) {
	return (
		<ResourceFigure
			icon={Briefcase}
			bgClassName="bg-teal-50 border-teal-200"
			iconClassName="text-teal-500"
			className={className}
		/>
	);
}
